// components/Hero.js
import React from 'react';
import './Hero.css';
import CodeBlock from './CodeBlock';

const Hero = () => {
  const installCode = `# Base installation
pip install cinder-ml

# Framework-specific installation
pip install "cinder-ml[pytorch]"    # PyTorch support
pip install "cinder-ml[tensorflow]" # TensorFlow support
pip install "cinder-ml[all]"        # All frameworks`;

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1>Machine Learning Model Architecture Analysis</h1>
          
          <p>
            Cinder is a Python library for analyzing machine learning model performance.
            It provides metrics, error analysis, and feature importance across PyTorch, 
            TensorFlow and scikit-learn models.
          </p>
          
          <div className="hero-buttons">
            <a href="#documentation" className="btn btn-primary">
              Documentation
            </a>
            <a href="#frameworks" className="btn btn-secondary">
              Framework Examples
            </a>
          </div>
        </div>
        
        <div className="hero-code">
          <div className="code-header">
            <div className="code-title">Installation</div>
          </div>
          <CodeBlock code={installCode} language="bash" />
        </div>
      </div>
    </section>
  );
};

export default Hero;